import React from 'react';
import { Box, Container } from '@mui/material';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import MiniCartDrawer from '../cart/MiniCartDrawer';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#fff' }}>
      {!isAdminRoute && <Header />}
      {isAdminRoute ? (
        <Box component="main" sx={{ flex: 1 }}>
          {children}
        </Box>
      ) : (
        <Container
          key={`${location.pathname}${location.search}`}
          component="main"
          sx={{
            flex: 1,
            py: { xs: 2.5, sm: 3, md: 4 },
            px: { xs: 1.5, sm: 2, md: 3 },
            animation: 'pageEnter 280ms cubic-bezier(0.2, 0.8, 0.2, 1)',
            '@keyframes pageEnter': {
              from: { opacity: 0, transform: 'translateY(10px)' },
              to: { opacity: 1, transform: 'translateY(0)' }
            },
            '@media (prefers-reduced-motion: reduce)': {
              animation: 'none'
            }
          }}
        >
          {children}
        </Container>
      )}
      {!isAdminRoute && <Footer />}
      <MiniCartDrawer />
    </Box>
  );
};

export default Layout; 